import styled, { css, keyframes } from "styled-components";

export const Shell = styled.section`
  position: fixed;
  bottom: 0;
  left: 220px;
  right: 0;
  z-index: 30;

  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -4px 20px rgba(15, 23, 42, 0.06);
  overflow: hidden;

  padding: 16px;
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 14px;

  /* 기본 높이 */
  max-height: 16vh;

  -webkit-overflow-scrolling: touch;
  transition: left 0.1s ease-in-out, max-height 0.18s ease;

  @media (max-width: 1200px) {
    left: 60px;
  }

  /* ✅ 마우스 올리면 위로 확장 */
  &:hover {
    max-height: min(52vh, 520px); /* 취향대로 */
  }

  /* ✅ 키보드 포커스(접근성)로도 확장되게 */
  &:focus-within {
    max-height: min(52vh, 520px);
  }
`;

export const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const shimmer = keyframes`
  0%   { transform: translateX(-60%); }
  100% { transform: translateX(160%); }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 4px;
  border-bottom: 1px dashed #e5e7eb;
`;

export const Title = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
`;

export const Count = styled.span`
  font-size: 12px;
  color: #64748b;
`;

export const List = styled.div`
  display: grid;
  gap: 10px;

  overflow: auto;
  min-height: 0;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;

  align-content: start;
  grid-auto-rows: max-content;

  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;

  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 999px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

export const Item = styled.div<{ $status: string }>`
  --ok: #16a34a;
  --pend: #f59e0b;
  --err: #ef4444;

  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  background: #ffffff;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0 auto 0 0;
    width: 3px;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    background: ${({ $status }) =>
      $status === "SUCCESS"
        ? "var(--ok)"
        : $status === "PENDING"
        ? "var(--pend)"
        : "var(--err)"};
  }

  ${({ $status }) =>
    $status === "PENDING"
      ? css`
          &::after {
            content: "";
            position: absolute;
            inset: 0;
            background: linear-gradient(
              90deg,
              rgba(148, 163, 184, 0) 0%,
              rgba(148, 163, 184, 0.12) 50%,
              rgba(148, 163, 184, 0) 100%
            );
            transform: translateX(-60%);
            animation: ${shimmer} 1.25s ease-in-out infinite;
            pointer-events: none;
          }
        `
      : ""}
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Name = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
`;

export const Job = styled.div`
  font-size: 12px;
  color: #475569;
`;

export const TaskId = styled.code`
  font-size: 12px;
  color: #334155;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 3px 6px;
`;

export const Badge = styled.span<{ $status: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid transparent;

  ${({ $status }) =>
    $status === "SUCCESS"
      ? `color:#065f46;background:#ecfdf5;border-color:#a7f3d0;`
      : $status === "PENDING"
      ? `color:#92400e;background:#fffbeb;border-color:#fde68a;`
      : `color:#991b1b;background:#fef2f2;border-color:#fecaca;`}
`;

export const Spinner = styled.i`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-right-color: transparent;
  display: inline-block;
  animation: ${spin} 0.8s linear infinite;
`;

export const Meta = styled.div`
  margin-left: auto;
  font-size: 11px;
  color: #64748b;
`;

export const Empty = styled.div`
  font-size: 13px;
  color: #64748b;
  padding: 8px 0;
`;

export const XButton = styled.button`
  margin-left: 8px;
  flex-shrink: 0;

  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  color: #475569;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  transition: transform 0.12s ease, background 0.12s ease,
    border-color 0.12s ease;

  &:hover {
    background: #f1f5f9;
    border-color: #d1d5db;
    transform: translateY(-1px);
  }
  &:active {
    transform: translateY(0);
  }

  &::before {
    content: "✕";
    font-size: 12px;
    line-height: 1;
  }
`;
